import { IPerformanceSlidersNames } from 'modules/admin-panel/pages/results/models';

export const getFocusAreaTypes = (
	performanceSlidersNames: IPerformanceSlidersNames,
) => {
	const {
		firstPerformanceSliderName,
		secondPerformanceSliderName,
		thirdPerformanceSliderName,
	} = performanceSlidersNames;

	return {
		1: {
			type: 'firstPerformanceResult',
			name: firstPerformanceSliderName,
			id: 1,
		},
		2: {
			type: 'secondPerformanceResult',
			name: secondPerformanceSliderName,
			id: 2,
		},
		3: {
			type: 'thirdPerformanceResult',
			name: thirdPerformanceSliderName,
			id: 3,
		},
	};
};
